// assets/spi-admin.js
window.SPIAdmin = {
  printScoreSheet() {
    window.print();
  }
};
